export const safeKill = (tween) => {
  if (tween && typeof tween.kill === 'function') {
    tween.kill();
  }
};
